import React, { useState, useEffect } from 'react';
import './style.css';
import loadingScreen from '../../../assets/images/IMS_Logo.png';

function Loader() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 100 : prev + 4));
    }, 80);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="loader">
      <img src={loadingScreen} alt="Loading" className="loader-logo" />
      <div className="loader-track">
        <div className="loader-fill" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}

export default Loader;
